import { Component, Input, OnInit } from '@angular/core';
import { AnswerDisplay, ProcessedPredictorAnswer, ProcessedValuePredictorQuestion } from '@fgb/core';

@Component({
    selector: 'fgbcl-answer-text-predictor-result',
    templateUrl: './answer-text-predictor-result.component.html',
    styleUrl: './answer-text-predictor-result.component.scss',
})
export class AnswerTextPredictorResultComponent implements OnInit {
    @Input() question: ProcessedValuePredictorQuestion;
    correctAnswer: ProcessedPredictorAnswer | undefined;
    selectedAnswer: ProcessedPredictorAnswer | undefined;

    answerDisplayTypes = AnswerDisplay;

    ngOnInit(): void {
        let answers = this.question.Answers.map(answers => answers as ProcessedPredictorAnswer);
        this.correctAnswer = answers.find(answer => answer.IsCorrect);
        this.selectedAnswer = answers.find(answer => answer.UserSelected);
    }

}
